'use client'

import { cn } from '@mntn-dev/ui-utilities'

import type { LanguageId } from '@mntn-dev/domain-types'
import { useTranslation } from '@mntn-dev/i18n'
import { type BackgroundImage, backgroundImageMap } from '@mntn-dev/ui-theme'

type ImageCardImageProps = Readonly<{
  image: BackgroundImage
  lng: LanguageId
}>

const ImageCardImage = ({ image }: ImageCardImageProps) => {
  const { t } = useTranslation('background-image')
  return (
    <div
      role="img"
      aria-label={t(image)}
      className={cn(
        `h-[18.75rem] ${backgroundImageMap[image]} bg-cover bg-center bg-no-repeat`
      )}
    />
  )
}

export { ImageCardImage, type ImageCardImageProps }
